Saving = window.Saving || {};

Saving = {
	init: function () {
		$('table.saving-funds').tablesorter({
			sortList: [[0,0]],
			sortLocaleCompare : true,
		});
		$('table.saving-funds-old').tablesorter({
			sortList: [[0,0]],
			sortLocaleCompare : true,
		});

		$('a', '.categorySelect').on('click', function(e) {
			e.preventDefault();
			var $this = $(this),
				$id = $this.attr('href');
			$this.siblings().removeClass('active');
			$this.toggleClass('active');

			$('section.category').removeClass('open');

			if ($this.hasClass('active')) {
				$($id).addClass('animated fadeIn open');
			}
		});

		$('a', '.info').on('click', function(e) {
			if(!$(e.target).is('.icon')){
				e.preventDefault();
				if (site.device.isTouch() || $('body').hasClass('tabbing')) {
					$(this).toggleClass('hover');
				}
			}
		});
	}
};
